import React from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function AssessmentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="card" style={{ padding: "1.5rem" }}>
      <h2>Assessment Detail — {id}</h2>
      <p>
        Placeholder for full assessment details. In production, fetch API data
        for <strong>{id}</strong>.
      </p>
      <button className="btn" onClick={() => navigate("/assessments")}>
        Back to List
      </button>
    </div>
  );
}
